import { Badge, ListGroup } from "react-bootstrap";
import React from 'react';
import { CSSTransition, TransitionGroup } from "react-transition-group";


export default function Order({order}) {
    return(
        <div className="order-section">
            {order.length > 0 && (
                <p className="order-section__title">Ваше замовлення</p>
            )}
            <ListGroup as="ol">
                <TransitionGroup className="order-list">
                    {order.map(i => (
                        <CSSTransition
                            key={i.id}
                            timeout={350}
                            classNames="item"
                        >
                            <ListGroup.Item as="li"
                            className="d-flex justify-content-between align-items-center">
                                <div className="fw-bold">{i.name} x {i.count}</div>
                                <Badge pill>{i.count * i.price}.00 грн.</Badge>
                            </ListGroup.Item>
                        </CSSTransition>
                    ))}
                </TransitionGroup>
            </ListGroup>
        </div>
    );
}
